import {
  BaseEditorExtension,
  mentionTableRowExtension,
} from '@copera/tiptap/extensions';
import { parseJsonToHtml } from '@copera/tiptap/parser';
import { useBoardTableRowDialog } from '@modules/board/BoardTableRowDialog';
import { useConversationDraft } from '@modules/conversation/state/ConversationDraft';
import { IconButton, Tooltip } from '@mui/material';
import { useCallback } from 'react';
import type { ChatMessageListItem, IChatConversation } from 'src/@types/chat';
import { PopoverTrigger } from 'src/components/PopoverTrigger';
import { Iconify } from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { useConversationContext } from 'src/provider/ConversationContext';
import { CreateTaskPopover } from './CreateTaskPopover';

export const CreateTaskAction = ({
  message,
  isOpened,
  conversation,
  getCurrentHtml,
}: {
  message: ChatMessageListItem;
  isOpened: (opened: boolean) => void;
  conversation: IChatConversation;
  getCurrentHtml: () => string;
}) => {
  const { translate } = useLocales();
  const { showBoardTableRowDialog } = useBoardTableRowDialog();
  const { setContent } = useConversationDraft(conversation._id);
  const { setReplyTo } = useConversationContext();

  const onCreate = useCallback(
    (rowId: string, boardId: string, tableId: string) => {
      showBoardTableRowDialog({
        boardId,
        rowId,
        tableId,
      });

      //we need parseMarkdownToDocument to parse the markdown to json
      // const tableRowMention = serializeDeepLink({
      //   type: DeepLinkEntity.TableRow,
      //   rowId,
      //   tableId,
      //   boardId,
      // });
      // const markdown = `[${tableRowMention}](${tableRowMention})`;
      // const docJSON = parseMarkdownToDocument(markdown);

      const docJSON = {
        type: 'doc',
        content: [
          {
            type: 'paragraph',
            content: [
              {
                type: 'mentionTableRow',
                attrs: { rowId, tableId, boardId },
              },
              { type: 'text', text: ' ' },
            ],
          },
        ],
      } as any;

      const html = parseJsonToHtml(docJSON, [
        mentionTableRowExtension.configure(),
        BaseEditorExtension.configure(),
      ]);
      setReplyTo(message);
      const current = getCurrentHtml();
      setContent(conversation._id, current + html);
    },
    [
      showBoardTableRowDialog,
      setContent,
      conversation._id,
      setReplyTo,
      message,
      getCurrentHtml,
    ],
  );

  return (
    <PopoverTrigger
      popover={CreateTaskPopover}
      context={{
        message,
        onCreate,
      }}
      isOpened={isOpened}
    >
      <Tooltip title={translate('shared.labels.create_task')}>
        <span>
          <IconButton size="small">
            <Iconify icon="tabler:copy-check" />
          </IconButton>
        </span>
      </Tooltip>
    </PopoverTrigger>
  );
};
